import { telegramGetPeerTmeUrl } from '#src/telegram.js';
export const telegramGetBotStartUrl = (username, contract, namedArg) => {
    const botUrl = telegramGetPeerTmeUrl({
        username,
    });
    botUrl.searchParams.append('start', `${contract.commandKey}_${contract.namedArg(namedArg)}`);
    return botUrl;
};
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
const contract = (commandKey, namedArg) => ({
    commandKey,
    namedArg,
});
export const Login = contract('login', ({ webLoginToken }) => webLoginToken);
export const Invite = contract('invite', ({ inviteToken }) => inviteToken);
export const Register = contract('register', ({ webRegisterToken }) => webRegisterToken);
//# sourceMappingURL=bot-start.js.map